import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expandable"
// Supports show/hide toggle for expandable content sections
//
// Targets:
//   - content: The element to show/hide
//   - icon: Optional icon to rotate on toggle
//   - label: Optional label text to update
//   - trigger: Optional trigger button (updates text between show/hide)
//
// Values:
//   - showText: Text to display when content is hidden (default from i18n)
//   - hideText: Text to display when content is shown (default from i18n)
//   - labelShowText: Text for label when collapsed (coordinates toggle)
//   - labelHideText: Text for label when expanded (coordinates toggle)
export default class extends Controller {
  static targets = ["content", "icon", "label", "trigger"]
  static values = {
    showText: { type: String, default: "詳細說明" },
    hideText: { type: String, default: "收合" },
    labelShowText: { type: String, default: "查看座標" },
    labelHideText: { type: String, default: "隱藏座標" }
  }

  connect() {
    // Initialize with collapsed state
    this.collapsed = true
  }

  toggle() {
    this.collapsed = !this.collapsed

    // Toggle content visibility
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden")
    }

    // Update trigger button text
    if (this.hasTriggerTarget) {
      this.triggerTarget.textContent = this.collapsed
        ? this.showTextValue
        : this.hideTextValue
    }

    // Update icon (supports both text and SVG icons)
    if (this.hasIconTarget) {
      // Check if icon is SVG (has transform class) or text
      if (this.iconTarget.tagName === 'svg' || this.iconTarget.querySelector('svg')) {
        // SVG icon: rotate 180deg when expanded
        if (this.collapsed) {
          this.iconTarget.classList.remove('rotate-180')
        } else {
          this.iconTarget.classList.add('rotate-180')
        }
      } else {
        // Text icon: change text content
        this.iconTarget.textContent = this.collapsed ? "▶" : "▼"
      }
    }

    // Update label text if target exists (uses configurable values)
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.collapsed
        ? this.labelShowTextValue
        : this.labelHideTextValue
    }
  }
}
